<template>
    <b-card no-body>
        <PayoutSummariesDrawer ref="drawer_payout_summary"></PayoutSummariesDrawer>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search...(case-sensitive)"
                    >
                    </base-input>
                    <base-input label="Filter by Status" class="mx-4">
                        <el-select
                            v-model="main_status"
                            multiple
                            collapse-tags
                            placeholder="Select Status"
                            >
                            <el-option
                                v-for="item in mainStatusList"
                                :key="item.status_id"
                                :label="item.status"
                                :value="item.status_id"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                empty-text="No Data"
                @selection-change="selectionChange"
                v-loading="isTableLoading"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed
                ></el-table-column>

                <el-table-column
                    label="Commission Slip"
                    min-width="160"
                >
                    <template slot-scope="scope">
                        <span class="mx-2">{{ scope.row.created_at | dateFormatShortString }}</span>
                        <!-- <span class="mx-2 font-weight-bold">{{ scope.row.rev_payout }}</span> -->
                    </template>
                </el-table-column>

                <el-table-column
                    label="Member/Hub"
                    min-width="150"
                    prop="name"
                >
                    <template slot-scope="scope">
                        <p v-if="scope.row.user" @click="$refs.drawer_payout_summary.viewDetails(scope.row)" class="name font-weight-500 text-primary mb-0 cursor-pointer">
                            {{ scope.row.user.name }}
                        </p>
                        <small v-if="scope.row.hub">{{ scope.row.hub.hub_name }}</small>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                    label="Status"
                    min-width="150"
                >
                    <template slot-scope="scope" >
                            <el-dropdown trigger="click">
                                <p class="el-dropdown-link top-line">
                                    <span :class="getRandomStatus().class">{{ getRandomStatus().value }}</span>
                                    <i class="el-icon-caret-bottom el-icon--right"></i>
                                </p>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>Monitor Cases</el-dropdown-item>
                                    <el-dropdown-item>Review &amp; Feedback</el-dropdown-item>
                                    <el-dropdown-item>Deny/Reject</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                    </template>
                </el-table-column> -->

                <el-table-column
                    label="Current Released"
                    min-width="160"
                >
                    <template slot-scope="scope">
                        <span class="mx-2 font-weight-bold">RM {{ scope.row.total_pay || 0 | moneyFormatter }}</span>
                        <!-- <span class="mb-0 top-line">{{ scope.row.total_pay }} <span class="text-muted">{{ scope.row.hub_target | moneyFormatter }}</span></span> -->
                        <!-- <span class="mb-0 top-line">{{ scope.row.actual_kpi_progress || 0 | moneyFormatter }} ({{ scope.row.percentage_kpi_progress || '0' }}%)/ <span class="text-muted">{{ scope.row.hub_target | moneyFormatter }}</span></span>
                        <b-progress height="7px" :value="scope.row.percentage_kpi_progress" :max="100.00" class="w-100" variant="success"></b-progress> -->
                    </template>
                </el-table-column>

                <el-table-column
                    label="Revenue Payout"
                    min-width="140"
                >
                    <template slot-scope="scope">
                        <span class="mx-2">{{ scope.row.actual_payout_revenue_point || 0 | moneyFormatter }}</span>
                        <!-- <span class="mx-2 font-weight-bold">{{ scope.row.rev_payout }}</span> -->
                    </template>
                </el-table-column>

                <!-- <el-table-column
                    label="Total Comm."
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <span class="mx-2">RM {{ scope.row.total_commision || 0 | moneyFormatter }}</span>
                    </template>
                </el-table-column> -->

                <!-- <el-table-column
                    label="Total Comm."
                    min-width="185"
                >
                    <template slot-scope="scope">
                        <b-avatar-group v-if="scope.row.team_members.length > 0" size="2.5rem" overlap="0.2">
                            <b-avatar v-for="member in scope.row.team_members.slice(0, 3)" :key="member.id" :src="member.avatar_url" :text="getInitials(member.name)"></b-avatar>
                            <b-avatar v-if="scope.row.team_members.length > 3" :key="scope.row.team_members.id" variant="secondary">{{ '+' + (scope.row.team_members.length - 3) }}</b-avatar>
                        </b-avatar-group>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column> -->

                <!-- <el-table-column
                    label="Balance Comm."
                    min-width="185"
                >
                    <template slot-scope="scope">
                            <span class="mx-2">RM {{ scope.row.balance_commision || 0 | moneyFormatter }}</span>
                    </template>
                </el-table-column> -->

                <el-table-column
                    label="Created/Updated"
                    min-width="190"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.created_at | dateFormatString }}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.updated_at | dateFormatFromNow }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                    width="50"
                >
                    <template slot-scope="scope">
                        <el-dropdown trigger="click"  style="cursor: pointer">
                            <p class="el-dropdown-link mb-0 top-line">
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="openModalAssignTo(scope.row,1)">View Change Log</el-dropdown-item>
                                <el-dropdown-item @click.native="openModalLeadAssignmentHistory(scope.row, scope.row)">Resend Payslip</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Tooltip, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import PayoutSummariesDrawer from '@/views/Commission/Payout/PayoutSummaries/PayoutSummariesDrawer.vue'
import { notifyFunctionMixin,axios,services,getHeader,swal, helperFunctionMixin } from '@/assets/js/httpImports.js'

export default {
    mixins: [clientPaginationMixin, notifyFunctionMixin, helperFunctionMixin],
    components: {
        BasePagination,
        PayoutSummariesDrawer,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: 
            [
                {
                    commission_slip_date: 'April 23',
                    member: "Kim Janey",
                    hub: "Hub Skypod",
                    status: "Paid",
                    total_pay:"4250",
                    rev_payout: "119000",
                    total_commision: "11900",
                    balance_commision: "7650",
                    created_at: "22 March 2022",
                    updated_at: "30 June 2022",
                },
                {
                    commission_slip_date: 'Sept 23',
                    member: "Chia W.L",
                    hub: "Hub PFCC",
                    status: "Paid",
                    total_pay:"3375",
                    rev_payout: "22500",
                    total_commision: "2500",
                    balance_commision: "1100",
                    created_at: "13 November 2022",
                    updated_at: "31 December 2022",
                },
            ],
            mainStatusList: [
                {status_id:1,status:"Pending Payment"},
                {status_id:2,status:"Close Cases"},
            ],
            main_status:""
        }
    },
    created() {
        this.getPayoutList();
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getInitials(name) {
            const names = name.split(' ');
            let initials = '';
            const maxInitials = 3;
            for (let i = 0; i < names.length && i < maxInitials; i++) {
                initials += names[i].charAt(0);
            }
            return initials;
        },
        getRandomStatus() {
            const statuses = [
                { value: 'KIV', class: 'text-warning' },
                { value: 'Pending', class: 'text-muted' },
                { value: 'Drop Case', class: 'text-danger' },
                { value: 'Success', class: 'text-success' },
            ];
            const randomIndex = Math.floor(Math.random() * statuses.length);
            return statuses[randomIndex];
        },
        getPayoutList() {
            axios.get(services.hub + 'hub_comms/direct_payout_detail.show_payout_list', {headers: getHeader()})
            .then(res  => {
                this.tableData = res.data.data;
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>